export const reactTableInitialState = {
  table_filters: [],
};
